import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'dashboard' },
      meta: {
        auth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
      meta: {
        title: Vue.i18n.translate('strings.profile', null),
        auth: true
      }
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import(/* webpackChunkName: "customers" */ '@/views/Customers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customers', null),
        auth: {
          roles: ['Admin'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'customerDetail',
        component: () => import(/* webpackChunkName: "customers" */ '@/views/Customers.vue')
      }]
    },
    {
      path: '/customers/:customerId/employees/',
      name: 'employees',
      component: () => import(/* webpackChunkName: "employees" */ '@/views/Employees.vue'),
      meta: {
        title: Vue.i18n.translate('strings.employees', null),
        auth: {
          roles: ['Admin'],
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/in-orders/:id/shipment/:idshipment',
      name: 'editShipment',
      component: () => import(/* webpackChunkName:  "project"  */ '@/components/in-order/ShipmentDetail.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.shipment.detail', null),
        auth: true
      }
    },
    {
      path: '/in-orders/:id/shipment/new',
      name: 'newShipment',
      component: () => import(/* webpackChunkName:  "project"  */ '@/components/in-order/ShipmentDetail.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.shipment,detail', null),
        auth: true
      }
    },
    {
      path: '/in-orders/:id/submittal/:idsubmittal',
      name: 'submittalDetails',
      component: () => import(/* webpackChunkName:  "project"  */ '@/components/in-order/SubmittalDetails.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.submittal.detail', null),
        auth: true
      }
    },
    {
      path: '/projects/:id/general',
      name: 'ProjectsGeneralDetail',
      component: () => import(/* webpackChunkName:  "project"  */ '@/views/ProjectsGeneralDetail.vue'),
      meta: {
        title: Vue.i18n.translate('strings.projects.detail', null),
        auth: true
      }
    },
    {
      path: '/in-orders',
      name: 'inOrders',
      component: () => import(/* webpackChunkName:  "inOrder"  */ '@/views/InOrders.vue'),
      meta: {
        title: Vue.i18n.translate('strings.in_orders', null),
        auth: true
      }
    },
    {
      path: '/in-orders/new',
      name: 'newInOrder',
      component: () => import(/* webpackChunkName:  "inOrder"  */ '@/views/InOrdersDetail.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.in_orders,detail', null),
        auth: true
      }
    },
    {
      path: '/in-orders/:id',
      redirect: '/in-orders/:id/scope',
      component: () => import(/* webpackChunkName:  "inOrder"  */ '@/views/InOrdersDetail.vue'),
      meta: {
        title: Vue.i18n.translate('strings.in_orders.detail', null),
        auth: true
      },
      children: [
        {
          path: '/in-orders/:id/scope',
          name: 'Scope',
          component: () => import(/* webpackChunkName:  "inOrderDetail"  */ '@/components/in-order/Scope.vue')
        },
        {
          path: '/in-orders/:id/submittals',
          name: 'Submittals',
          component: () => import(/* webpackChunkName:  "inOrderDetail"  */ '@/components/in-order/Submittals.vue')
        },
        {
          path: '/in-orders/:id/change-orders',
          name: 'ChangeOrders',
          component: () => import(/* webpackChunkName:  "inOrderDetail"  */ '@/components/in-order/ChangeOrders.vue')
        },
        {
          path: '/in-orders/:id/payments',
          name: 'Payments',
          component: () => import(/* webpackChunkName:  "inOrderDetail"  */ '@/components/in-order/Payments.vue')
        },
        {
          path: '/in-orders/:id/shipments',
          name: 'Shipments',
          component: () => import(/* webpackChunkName:  "inOrderDetail"  */ '@/components/in-order/Shipments.vue')
        },
        {
          path: '/in-orders/:id/gallery',
          name: 'Gallery',
          component: () => import(/* webpackChunkName:  "inOrderDetail"  */ '@/components/in-order/Gallery.vue')
        },
        {
          path: '/in-orders/:id/delivery-dates',
          name: 'Delivery',
          component: () => import(/* webpackChunkName:  "inOrderDetail"  */ '@/components/in-order/DeliveryDates.vue')
        },
        {
          path: '/in-orders/:id/field-used-drawings',
          name: 'Drawing',
          component: () => import(/* webpackChunkName:  "inOrderDetail"  */ '@/components/in-order/FieldUsedDrawings.vue')
        }
      ]
    },
    {
      path: '/to-quotes',
      name: 'toQuotes',
      component: () => import(/* webpackChunkName:  "toQuote"  */ '@/views/ToQuotes.vue'),
      meta: {
        title: Vue.i18n.translate('strings.to_quotes', null),
        auth: {
          roles: ['Admin', 'Customer'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'toQuoteDetail',
        component: () => import(/* webpackChunkName:  "toQuote"  */ '@/views/ToQuotes.vue')
      }]
    },
    {
      path: '/to-quotes/:id',
      name: 'toQuotesAdd',
      component: () => import(/* webpackChunkName:  "quote"  */ '@/views/ToQuotes.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.to_quotes', null),
        auth: true
      }
    },
    {
      path: '/to-quotes/customer/:customerId/',
      name: 'toQuotesCustomer',
      component: () => import(/* webpackChunkName:  "project"  */ '@/views/ToQuotes.vue'),
      meta: {
        title: Vue.i18n.translate('strings.to_quotes', null),
        auth: true
      }
    },
    {
      path: '/cancelled',
      name: 'cancelled',
      component: () => import(/* webpackChunkName:  "quote"  */ '@/views/Cancelled.vue'),
      meta: {
        title: Vue.i18n.translate('strings.cancelled', null),
        auth: true
      }
    },
    {
      path: '/cancelled/customer/:customerId/',
      name: 'canceledCustomer',
      component: () => import(/* webpackChunkName:  "project"  */ '@/views/Cancelled.vue'),
      meta: {
        title: Vue.i18n.translate('strings.cancelled', null),
        auth: true
      }
    },
    {
      path: '/quotes',
      name: 'quotes',
      component: () => import(/* webpackChunkName:  "quote"  */ '@/views/Quotes.vue'),
      meta: {
        title: Vue.i18n.translate('strings.quotes', null),
        auth: true
      }
    },
    {
      path: '/quotes/customer/:customerId/',
      name: 'quotesCustomer',
      component: () => import(/* webpackChunkName:  "project"  */ '@/views/Quotes.vue'),
      meta: {
        title: Vue.i18n.translate('strings.quotes', null),
        auth: true
      }
    },
    {
      path: '/rfis',
      name: 'rfis',
      component: () => import(/* webpackChunkName:  "rfi"  */ '@/views/Rfis.vue'),
      meta: {
        title: Vue.i18n.translate('strings.rfis', null),
        auth: true
      },
      children: [{
        path: ':id',
        name: 'rfiDetail',
        component: () => import(/* webpackChunkName:  "rfi"  */ '@/views/Rfis.vue')
      }]
    },
    {
      path: '/rfis/project/:id',
      name: 'rfisProject',
      component: () => import(/* webpackChunkName:  "rfi"  */ '@/views/Rfis.vue'),
      meta: {
        title: Vue.i18n.translate('strings.rfis', null),
        auth: true
      }
    },
    {
      path: '/revisions/:idQuote',
      name: 'revisions',
      props: true,
      component: () => import(/* webpackChunkName: "revisions" */ '@/components/in-order/Revisions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.revisions', null),
        auth: true
      }
    },
    {
      path: '/finished',
      name: 'finished',
      component: () => import(/* webpackChunkName:  "finished"  */ '@/views/Finisheds.vue'),
      meta: {
        title: Vue.i18n.translate('strings.finished', null),
        auth: true
      }
    },
    {
      path: '/finished/:idFinisheds/payments',
      name: 'Payments',
      component: () => import(/* webpackChunkName:  "payments"  */ '@/views/PaymentsFinisheds.vue')
    },
    {
      path: '/quotation-files/:id',
      name: 'quotationFiles',
      component: () => import(/* webpackChunkName:  "quotationFile"  */ '@/views/QuotationFiles.vue'),
      meta: {
        title: Vue.i18n.translate('strings.quotation_files', null),
        auth: true
      }
    },
    {
      path: '/employees',
      name: 'employees',
      component: () => import(/* webpackChunkName: "employees" */ '@/views/Employees.vue'),
      meta: {
        title: Vue.i18n.translate('strings.employees', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'employeesDetail',
        component: () => import(/* webpackChunkName: "employees" */ '@/views/Employees.vue')
      }]
    },
    {
      path: '/project_contacts',
      name: 'project_contacts',
      component: () => import(/* webpackChunkName: "project_contacts" */ '@/views/ProjectContacts.vue'),
      meta: {
        title: Vue.i18n.translate('strings.project_contacts', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'projectContactsDetail',
        component: () => import(/* webpackChunkName: "project_contacts" */ '@/views/ProjectContacts.vue')
      }]
    },
    // New Route
    {
      path: '/users/new',
      name: 'AddUser',
      component: () => import(/* webpackChunkName:  "project"  */ '@/views/AddUser.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue')
      }]
    },
    {
      path: '/users/:id/edit/notifications',
      name: 'editNotifications',
      component: () => import(/* webpackChunkName:  "project"  */ '@/views/EditNotifications.vue'),
      props: true,
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/AuthLogin.vue'),
      meta: {
        title: Vue.i18n.translate('login.login', null),
        auth: false
      }
    },
    {
      path: '/terms-and-conditions',
      name: 'TermsAndConditions',
      component: () => import(/* webpackChunkName: "TermsAndConditions" */ '@/views/TermsAndConditions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.terms_and_conditions', null)
      }
    },
    // {
    //   path: '/register',
    //   name: 'register',
    //   // route level code-splitting
    //   // this generates a separate chunk (register.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "register" */ '@/views/Auth/AuthRegister.vue'),
    //   meta: {
    //     title: Vue.i18n.translate('login.register', null),
    //     auth: false
    //   }
    // },
    {
      path: '/password/reset',
      name: 'reset',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetLink.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/password/reset/:token',
      name: 'reset.token',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetForm.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/email/verify',
      name: 'verification.notice',
      props: true,
      component: () => import(/* webpackChunkName: "verification" */ '@/views/Auth/AuthVerify.vue'),
      meta: {
        title: Vue.i18n.translate('verification.title', null),
        auth: false
      }
    }
  ]
})

// It's required for VueAuth
Vue.router = router

export default router
